module.exports = __webpack_public_path__ + "assets/img/logo.3cbdf313.png";